<template>
  <div>
    <div>
      <span style="font-size: 14px; color: #606266">学段：</span>
      <span class="carry_stage" :class="{ stageA: item.code === stageCode }" @click="stageClick(item.code)" v-for="item in stageList" :key="item.code">{{ item.name }}</span>
    </div>
  </div>
</template>
<script>
import { dictCode, usercenterinfo, schoolReportList } from '@/api/home'
export default {
  data() {
    return {
      stageList: [],
      stageCode: '',
      stageName: ''
    }
  },
  created() {
    this.dictCodeStage()
  },
  methods: {
    // 获取学段
    async dictCodeStage() {
      const { data: res } = await dictCode({
        code: 'stage'
      })
      this.stageCode = res.data[0].code
      this.stageName = res.data[0].name
      this.stageList = res.data
      this.$emit('stageEmit', this.stageCode)
      this.stageNameEmit()
    },
    // 学段点击事件
    stageClick(code) {
      this.stageCode = code
      this.stageList.forEach((item) => {
        if (item.code == this.stageCode) {
          this.stageName = item.name
        }
      })
      this.$emit('stageClickEmit', this.stageCode)
      this.stageNameEmit()
    },
    // 学段名称回调
    stageNameEmit() {
      this.$emit('stageNameEmit', this.stageName)
    }
  }
}
</script>
<style scoped>
.carry_stage {
  margin: 0 10px;
  font-size: 14px;
  cursor: pointer;
}
.stageA {
  color: #2a8bf8;
}
</style>


// WEBPACK FOOTER //
// src/views/school/components/components/phaseStudying.vue